import { Component, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CameraComponent } from "../camera/camera.component";

@Component({
  selector: "app-update-dialog",
  template: `
    <h2 mat-dialog-title>A new version of this application is available</h2>
    <div mat-dialog-actions style="display:block" class="ml-auto mr-auto w-25">
      <button mat-button cdkFocusInitial mat-raised-button color="primary" style="float: right" (click)="success()">
        Update
      </button>
    </div>
  `,
})
export class AppUpdateDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<AppUpdateDialogComponent>) {}

  success(): void {
    this.dialogRef.close(true);
  }

  ngOnInit() {}
}
